import { firebase } from '@/firebase/firebase'
import modelProject from "@/models/Project"

const state = {
  projects:[]
}
const getters = {
  projects: state =>{
    return state.projects
  },
  projectByID: (state)=>(id) =>{
    //console.log('getters',id);
    var res = state.projects.find(elem => elem.id===id)
    if (!res) {
      res = new modelProject({})
    }
    return res
  },
  projectsByStatus: (state)=>(status) =>{
    return state.projects.filter(elem => elem.status===status)
  },
  myProjects: (state)=>{
    return state.projects.filter(elem => elem.my===true)
  }
}
const mutations = {
  setProjects (state, value) {
    //console.log('mutation set events '+value);
    state.projects = value;
  }
}
const actions = {
  async fetchProjects({state,commit,rootGetters}) {
    console.log('store.projects.fetchProjects ',rootGetters["auth/uid"]);
    await firebase.firestore().collection("Projects").where("active","==",true).onSnapshot(docdata => {
      let arr = []
      docdata.forEach(function(doc) {
        let elem = new modelProject(doc.data())
        elem.id = doc.id
        //console.log('project',elem.num,doc.data().investments)

        if (doc.data().investments) {
          elem.myInvestments = doc.data().investments.filter(elem => elem.userID===rootGetters["auth/uid"])
          elem.my = (elem.myInvestments.length>0)
          elem.sumMy = elem.myInvestments.reduce((total, p) => {return total + p.sum}, 0)
        }
        arr.push(elem)
        //TODO1 мои инвестиции читать из аккаунта
      })
      commit("setProjects",  arr)
    })
  },
  async investToProject({state,commit,rootState},params) {
      console.log('store.account.investToProject:',rootState.auth.uid, params)
      var fnc = firebase.functions().httpsCallable('makeInvest');
      return await fnc({sum: Number(params.sum),userID:rootState.auth.uid,projectID:params.projectID}).then((result)=>{
          console.log('transaction result',result.data);
        })
  }
}
const storeConf = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
export default storeConf



// WEBPACK FOOTER //
// ./storage/modules/projectsstore.js